import { createAction } from 'redux-actions';

import * as C from './constants';

export const getRegistrantListRequest = createAction(C.GET_REGISTRANT_LIST_REQUEST);
export const getRegistrantListSuccess = createAction(C.GET_REGISTRANT_LIST_SUCCESS);
